/**
 * Toma un valor y devuelve true o false según las
 * siguientes condiciones:
 *
 * Si es string, ['',
 * 'false'].includes(value.toLowerCase()) => false, todo lo
 * demás => true.
 *
 * Si es array, [] => false, [...] => true.
 *
 * Todo lo demás !!value
 *
 * @example
 *
 * toBoolean('true') // true
 * toBoolean('TrUE') // true
 * toBoolean('FAlSe') // false
 * toBoolean(0) // false
 * toBoolean(1) // true
 * toBoolean([0]) // true
 * toBoolean([]) // false
 */
export function toBoolean(value: unknown): boolean {
  if (typeof value === 'string') {
    return !['false', ''].includes(value.toLowerCase());
  }

  if (Array.isArray(value)) return value.length > 0;

  return !!value;
}
